import { useEffect, useState } from "react";
import { IoDownloadOutline, IoEllipsisVertical, IoLinkOutline, IoTrashOutline, IoWalletOutline } from "react-icons/io5";
import API from "@/services/api";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const exportColumns = ["module_name", "title", "resource_profile", "charge", "urgent", "points", "estimation", "days_required", "status", "NNL", "comments", "status_todo_date", "lastest_status_date"];

export const MultiAction = ({ selectedItems, items, handleMultipleDelete, project, calculateEstimation }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [itemsToProcess, setItemsToProcess] = useState(selectedItems.length > 0 ? selectedItems : items);

  useEffect(() => {
    setItemsToProcess(selectedItems.length > 0 ? selectedItems : items);
  }, [selectedItems, items]);

  const downloadCSV = () => {
    const csvData = [exportColumns.map((column) => column)];
    itemsToProcess.forEach((item) => {
      const rowData = exportColumns?.map((column) => {
        if (column === "comments") {
          if (!item.comments) return '""';
          return `"${item.comments
            .map((e) => {
              if (!e?.text) return "";
              return e.text.replace(/<[^>]*>?/gm, "");
            })
            .join("\n")
            .replace(/"/g, '""')}"`;
        }
        
        // Utiliser la valeur calculée pour l'estimation
        if (column === "estimation" && calculateEstimation) {
          const calculatedValue = calculateEstimation(item);
          return `"${calculatedValue || ""}"`;
        }

        // Handle the new date fields to format nicely
          if (column === "status_todo_date" || column === "lastest_status_date") {
            const dateValue = item[column] ? new Date(item[column]).toISOString() : "";
            return `"${dateValue}"`;
          }
        
        const key = column === "module_name" ? "module_name" : column;
        const value = item[key];
        return `"${value ? String(value).replace(/"/g, '""') : ""}"`;
      });
      csvData.push(rowData);
    });

    const csvContent = csvData.map((row) => row.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "exported_roadlog_items.csv";
    link.click();
  };

  const linkToQuote = async () => {
    const { data, ok } = await API.post("/quote", {
      name: project.name + " - " + new Date().toLocaleDateString("fr", { day: "numeric", month: "short", year: "numeric" }),
      project_id: project._id,
      project_name: project.name,
      category: "PROPAL",
      lang: "en",
    });
    if (!ok) return toast.error("Error creating quote");

    generateQuotePages(data);

    toast.success("Items linked to quote");
  };

  const generateQuotePages = async (quote) => {
    try {
      const chunks = [];
      for (let i = 0; i < itemsToProcess.length; i += 20) {
        chunks.push(itemsToProcess.slice(i, i + 20));
      }

      let lastPosition = 0;
      let totalEstimation = 0;
      let totalDays = 0;

      for (const chunk of chunks) {
        const page = {
          position: lastPosition,
          format: "A4",
          quote_id: quote._id,
          quote_name: quote.name,
          background_image_url: "https://bank.cellar-c2.services.clever-cloud.com/filebgImage/9146709e9582992ec6bc4910ed545904/background.png",
        };

        const resP = await API.post("/quote_page", page);
        if (!resP.ok) throw resP;

        const block = {
          type: "table",
          quote_id: quote._id,
          quote_name: quote.name,
          quote_page_id: resP.data._id,
          isTemplate: false,
          display_footer: false,
          arr: chunk.map((item) => {
            const description = {
              fr: `
                <div>
                  ${item.module_name ? `<span>[${item.module_name}] ${item.title}</span>` : `<span>${item.title}</span>`}
                </div>
              `,
              en: `
                <div>
                  ${item.module_name ? `<span>[${item.module_name}] ${item.title}</span>` : `<span>${item.title}</span>`}
                </div>
              `,
            };

            const daysRequired = item.days_required || 1;
            const estimation = item.estimation;
            const pricePerDay = estimation / daysRequired;

            totalEstimation += estimation;
            totalDays += daysRequired;

            return {
              description,
              price: pricePerDay,
              min_quantity: daysRequired,
              max_quantity: daysRequired,
              min_total: estimation,
              max_total: estimation,
              tax: 0,
              quantity: daysRequired,
              total: estimation,
            };
          }),
        };

        const resB = await API.post("/quote_block", block);
        if (!resB.ok) throw resB;

        if (lastPosition === chunks.length - 1) {
          const titleTotalBlock = {
            type: "text",
            quote_id: quote._id,
            quote_name: quote.name,
            quote_page_id: resP.data._id,
            isTemplate: false,
            description: {
              fr: `<div><span>Total : ${totalDays} jours - ${totalEstimation}€</span></div>`,
              en: `<div><span>Total: ${totalDays} days - ${totalEstimation}€</span></div>`,
            },
          };

          const resTitleBlock = await API.post("/quote_block", titleTotalBlock);
          if (!resTitleBlock.ok) throw resTitleBlock;
        }

        lastPosition += 1;
      }

      toast.success(`Created ${chunks.length} pages with ${itemsToProcess.length} items`);

      if (window.confirm(`Items linked to quote across ${chunks.length} pages!\n\nDo you want to be redirected to the quote page?\nCancel to stay on this page.`)) {
        navigate(`/quote/${quote._id}`);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to link quote");
    }
  };

  const createBudget = async () => {
    try {
      console.log("itemsToProcess", itemsToProcess);
      const totalEstimation = itemsToProcess.reduce((acc, item) => acc + Number(item.estimation || 0), 0);
      const totalDays = itemsToProcess.reduce((acc, item) => acc + Number(item.days_required || 0), 0);

      console.log(`totalEstimation: ${totalEstimation} - totalDays: ${totalDays}`);

      const { data: budget, ok } = await API.post("/budget", {
        projectId: project._id,
        projectName: project.name,
        name: `${project.name} - ${new Date().toLocaleDateString("fr", {
          day: "numeric",
          month: "short",
          year: "numeric",
        })}`,
        frequency: "one-time",
        value: totalEstimation,
        amount: totalEstimation,
        startAt: new Date(),
        endAt: new Date(Date.now() + totalDays * 24 * 60 * 60 * 1000),
        description: `Budget generated from ${itemsToProcess.length} roadlog items`,
        facturation_type: "forfait",
      });

      if (!ok) throw new Error("Failed to create budget");

      for (const item of itemsToProcess) {
        await API.put(`/roadlog_item/${item._id}`, { budget_id: budget._id, budget_name: budget.name });
      }

      toast.success(`Budget created with ${itemsToProcess.length} items`);

      if (window.confirm("Budget created! Would you like to view it?")) {
        navigate(`/project/${project._id}/budget-normal`);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to create budget");
    }
  };

  return (
    <div className="relative">
      <button
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        className="inline-flex justify-between items-center gap-4 px-2 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
        <IoEllipsisVertical className="w-4 h-4" />
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0" onClick={() => setIsOpen(false)} />
          <div className="absolute top-full right-0 w-56 bg-white border border-gray-200 rounded-lg shadow-xl z-10 overflow-hidden animate-fadeIn">
            <div className="py-2">
              <button
                onClick={handleMultipleDelete}
                className="w-full px-4 py-2.5 text-left text-sm font-medium text-red-600 hover:bg-red-50 transition-colors duration-200 cursor-pointer flex items-center gap-2">
                <IoTrashOutline className="w-4 h-4" />
                Delete {selectedItems.length > 0 ? `(${selectedItems.length} items)` : "All"}
              </button>

              <button
                onClick={downloadCSV}
                className="w-full px-4 py-2.5 text-left text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors duration-200 cursor-pointer flex items-center gap-2">
                <IoDownloadOutline className="w-4 h-4" />
                Export CSV {selectedItems.length > 0 ? `(${selectedItems.length} items)` : ""}
              </button>

              <button
                onClick={linkToQuote}
                className="w-full px-4 py-2.5 text-left text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors duration-200 cursor-pointer flex items-center gap-2">
                <IoLinkOutline className="w-4 h-4" />
                Link to Quote {selectedItems.length > 0 ? `(${selectedItems.length} items)` : ""}
              </button>
              <button
                onClick={createBudget}
                className="w-full px-4 py-2.5 text-left text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors duration-200 cursor-pointer flex items-center gap-2">
                <IoWalletOutline className="w-4 h-4" />
                Generate a new budget {selectedItems.length > 0 ? `(${selectedItems.length} items)` : ""}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
